import { usePaymentMethod } from "contexts/v1/masterData/PaymentMethodContext";
import React, { useState, useEffect } from "react";
import { Card, Row, Col, Form, Button, Badge } from "react-bootstrap";
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";

const FilterCard = ({ filterOptions, updateFilter, clearFilters }) => {
  // const [paymentMethods, setPaymentMethods] = useState([]);
    const { paymentMethods } = usePaymentMethod();
  const [cashierSessions, setCashierSessions] = useState([]);
  const [locations] = useState([
    { value: "bar", label: "Bar", icon: "🍸" },
    { value: "coffee_shop", label: "Coffee Shop", icon: "☕" },
    { value: "merchandise", label: "Merchandise", icon: "🛍️" },
  ]);

  

  // Fetch payment methods
  // useEffect(() => {
  //   const fetchPaymentMethods = async () => {
  //     try {
  //       const response = await getRequest("/payment-method");
  //       if (response.success) {
  //         setPaymentMethods(response.data || []);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching payment methods:", error);
  //     }
  //   };
  //   fetchPaymentMethods();
  // }, []);

  // Fetch cashier sessions
  useEffect(() => {
    const fetchCashierSessions = async () => {
      try {
        const queryString = buildQueryString({
          include: "cashier",
          limit: 50,
        });
        const response = await getRequest(`/cashier-session${queryString}`);
        if (response.success) {
          setCashierSessions(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching cashier sessions:", error);
      }
    };
    fetchCashierSessions();
  }, []);

  const handleFilterChange = (key, value) => {
    updateFilter(key, value);
  };

  const getActiveFiltersCount = () => {
    const filters = filterOptions.filters;
    let count = 0;
    if (filters.payment_method_id) count++;
    if (filters.cashier_session_id) count++;
    if (filters.location) count++;
    // Don't count inserted_at as it has default value
    return count;
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h6 className="mb-0">Filters</h6>
          {getActiveFiltersCount() > 0 && (
            <Badge bg="primary" text="light" >{getActiveFiltersCount()} active</Badge>
          )}
        </div>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={clearFilters}
          disabled={getActiveFiltersCount() === 0}
        >
          Clear All
        </Button>
      </Card.Header>
      <Card.Body>
        <Row>
          {/* Date Filter */}
          <Col md={3}>
            <Form.Group>
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={filterOptions.filters.inserted_at}
                onChange={(e) =>
                  handleFilterChange("inserted_at", e.target.value)
                }
              />
            </Form.Group>
          </Col>

          {/* Payment Method Filter */}
          <Col md={3}>
            <Form.Group>
              <Form.Label>Payment Method</Form.Label>
              <Form.Select
                value={filterOptions.filters.payment_method_id}
                onChange={(e) =>
                  handleFilterChange("payment_method_id", e.target.value)
                }
              >
                <option value="">All Payment Methods</option>
                {paymentMethods.data.map((method) => (
                  <option key={method.id} value={method.id}>
                    {method.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Location Filter */}
          <Col md={3}>
            <Form.Group>
              <Form.Label>Location</Form.Label>
              <Form.Select
                value={filterOptions.filters.location}
                onChange={(e) => handleFilterChange("location", e.target.value)}
              >
                <option value="">All Locations</option>
                {locations.map((location) => (
                  <option key={location.value} value={location.value}>
                    {location.icon} {location.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          {/* Cashier Session Filter */}
          {/* <Col md={3}>
            <Form.Group>
              <Form.Label>Cashier Session</Form.Label>
              <Form.Select
                value={filterOptions.filters.cashier_session_id}
                onChange={(e) =>
                  handleFilterChange("cashier_session_id", e.target.value)
                }
              >
                <option value="">All Sessions</option>
                {cashierSessions.map((session) => (
                  <option key={session.id} value={session.id}>
                    {session.cashier?.name ||
                      `Session ${session.id.slice(0, 8)}`}{" "}
                    - {session.location}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col> */}
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FilterCard;
